import api from "../api";

export async function addTestimonial(formData: FormData) {
  const res = await api.post("/testimonials", formData);
  return res.data.testimonial;
}

export async function deleteTestimonial(id: number | string) {
  const res = await api.delete(`/testimonials/${id}`);
  return res.data.success;
}

export async function fetchTestimonials() {
  const res = await api.get("/testimonials");
  return res.data.testimonials || [];
}

export async function hideTestimonial(id: number | string) {
  const res = await api.post(`/testimonials/${id}/hide`);
  return res.data.success;
}

export async function unhideTestimonial(id: number | string) {
  const res = await api.post(`/testimonials/${id}/unhide`);
  return res.data.success;
}

export async function updateTestimonial(
  id: number | string,
  formData: FormData,
) {
  const res = await api.post(`/testimonials/${id}`, formData);
  return res.data.testimonial;
}
